function adicionarAtributosBasicosTeste(el, valor) {
    if (!el.getAttribute('data-label')) {
        el.setAttribute('data-label', valor);
    };
    if (!el.getAttribute('data-cy')) {
        el.setAttribute('data-cy', valor);
    }
}

function adicionarAtributoCustomizadoTeste(el, binding) {
    const attributeName = binding.arg;
    if (!!attributeName) {
        el.setAttribute(attributeName, binding.value);
    };
}

function atualizarAtributosBasicosTeste(el, binding) {
    const valorDataLabel = el.getAttribute('data-label');
    const valorDataCy = el.getAttribute('data-cy');
    if (valorDataLabel == binding.oldValue && valorDataLabel != binding.value) {
        el.setAttribute('data-label', binding.value);
    };
    if (valorDataCy == binding.oldValue && valorDataCy != binding.value) {
        el.setAttribute('data-cy', binding.value);
    }
}

function atualizarAtributoCustomizadoTeste(el, binding) {
    const attributeName = binding.arg;
    if (!!attributeName && el.getAttribute(attributeName) == binding.oldValue && el.getAttribute(attributeName) != binding.value) {
        el.setAttribute(attributeName, binding.value);
    };
}

export const ve2e = {
    mounted: (el, binding, vnode, prevNode) => {
        if(!binding.arg) {
            adicionarAtributosBasicosTeste(el, binding.value);
        } else {
            adicionarAtributoCustomizadoTeste(el, binding);
        }
    },
    updated: (el, binding, vnode, prevVnode) => {
        if(!binding.arg) {
            atualizarAtributosBasicosTeste(el, binding);
        } else {
            atualizarAtributoCustomizadoTeste(el, binding);
        }
    }
  };